export default {
    railHeight: '4px',
    railWidthVertical: '4px',
    handleSize: '18px',
    dotHeight: '8px',
    dotWidth: '8px',
    dotBorderRadius: '4px'
};
